import { PayloadAction } from '@reduxjs/toolkit';
import { TemplatesReducerCreator } from '../types';

const deleteThemePackSyncReducer = (create: TemplatesReducerCreator) => {
  return create.reducer((state, action: PayloadAction<number[]>) => {
    if (action.payload) {
      state.themePacks = state.themePacks?.filter((theme) => !action.payload.includes(theme.color_pack)) ?? [];
    }
  });
};

export default deleteThemePackSyncReducer;
